import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/dashboard/dashboard.driftSummaries.query.gql"
import type {
  DashboardDriftSummariesQuery,
  DashboardDriftSummariesQueryVariables,
} from "@/v2-backoffice-client/uptime/dashboard/__types__/dashboard.driftSummaries.query"

type Options = QueryHookOptions<
  DashboardDriftSummariesQuery,
  DashboardDriftSummariesQueryVariables
>

export function useDashboardDriftSummariesQuery(options?: Options) {
  return useQuery<
    DashboardDriftSummariesQuery,
    DashboardDriftSummariesQueryVariables
  >(query, options)
}
